// src/storeAPIs/StoreCategoriesApis.js
import apiClient from "../utils/Http";

// ===== BASIC CRUD OPERATIONS =====
export const storeGetAllCategories = (params = {}) =>
  apiClient.get("api/store/categories/", { params });

export const storeGetCategoryBySlug = (slug) =>
  apiClient.get(`api/store/categories/${slug}/`);

export const storeCreateCategory = (data) =>
  apiClient.post("api/store/categories/", data);

export const storeUpdateCategory = (slug, data) =>
  apiClient.put(`api/store/categories/${slug}/`, data);

export const storePatchCategory = (slug, data) =>
  apiClient.patch(`api/store/categories/${slug}/`, data);

export const storeDeleteCategory = (slug) =>
  apiClient.delete(`api/store/categories/${slug}/`);

// ===== TREE / HIERARCHY =====
export const storeGetCategoryTree = () =>
  apiClient.get("api/store/categories/tree/");

// ===== FILTERING =====
export const storeGetRootCategories = (params = {}) =>
  apiClient.get("api/store/categories/", {
    params: { ...params, parent__isnull: true },
  });

export const storeGetCategoriesByParent = (parentId, params = {}) =>
  apiClient.get("api/store/categories/", {
    params: { ...params, parent: parentId },
  });

export const storeGetCategoriesByParentSlug = (parentSlug, params = {}) =>
  apiClient.get("api/store/categories/", {
    params: { ...params, parent__slug: parentSlug },
  });

// ===== SEARCH =====
export const storeSearchCategories = (query, params = {}) =>
  apiClient.get("api/store/categories/", {
    params: { ...params, search: query },
  });

// ===== ORDERING =====
export const storeGetCategoriesOrderedByName = (params = {}) =>
  apiClient.get("api/store/categories/", {
    params: { ...params, ordering: "name" },
  });

// ===== PAGINATION =====
export const storeGetCategoriesPage = (page = 1, pageSize = 20, params = {}) =>
  apiClient.get("api/store/categories/", {
    params: { ...params, page, page_size: pageSize },
  });
  export function storeGetProductBySlug(slug) {
  return apiClient.get(`api/store/products/${slug}/`);
}